import { render, staticRenderFns } from "./listaParceiros.vue?vue&type=template&id=5358a74a&scoped=true&"
import script from "./listaParceiros.vue?vue&type=script&lang=js&"
export * from "./listaParceiros.vue?vue&type=script&lang=js&"
import style0 from "./listaParceiros.vue?vue&type=style&index=0&id=5358a74a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5358a74a",
  null
  
)

export default component.exports